module.exports = __webpack_public_path__ + "img/sixday1-1.00f1c317.jpg";